import { put, take, all } from 'redux-saga/effects'
import { SUCCESS } from 'crom-api-constants'
import _ from 'lodash'

import { loadGroups } from '../../../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/GroupsContent/actions'

import { error, success } from '../../../../../services/toastr'

import {
    loadGroupMembers,
    groupStackChangeNameBeingEdited,
} from '../../../../../scenes/Gnosus/components/GroupStack/actions'
import {
    LOAD_GROUP_MEMBERS_REQUEST,
    SETUP_GROUP_STACK,
} from '../../../../../scenes/Gnosus/components/GroupStack/constants'

import { manageGroupsDialogSetRowLoading } from '../actions'
import { LOCALE_PREFIX } from '../constants'

import { getEntIdsByCountry, getResponseObject, importMembersCall } from '../helpers'

const COUNTRY = {
    CZ: 'cz',
    SK: 'sk',
}

const responseBodyPath = 'success.payload.response.body'

export default function* dialogImportCallSaga(action) {
    const groupId = _.get(action, 'data.groupId', null)
    const entities = _.get(action, 'data.entities', [])
    const index = _.get(action, 'data.index', null)
    const newGroup = _.get(action, 'data.newGroup', false)

    yield put(manageGroupsDialogSetRowLoading(index, true))

    const czechEntities = getEntIdsByCountry(entities, 'CZ')
    const skEntities = getEntIdsByCountry(entities, 'SK')

    // Individual requests. Doesn't create a request if there are no entities for given country because it would fail
    const czechResponse = !_.isEmpty(czechEntities)
        ? yield importMembersCall(czechEntities, groupId, COUNTRY.CZ, index)
        : {}
    const skResponse = !_.isEmpty(skEntities) ? yield importMembersCall(skEntities, groupId, COUNTRY.SK, index) : {}

    if ((!czechResponse.failed && !_.isEmpty(czechResponse)) || (!skResponse.failed && !_.isEmpty(skResponse))) {
        // If any request failed show error message;
        // but the other request might have succeded - don't break saga (if the request was created - check for entities)
        if (czechResponse.failed && !_.isEmpty(skEntities)) error({ id: `${LOCALE_PREFIX}.czImportFail` })
        if (skResponse.failed && !_.isEmpty(czechEntities)) error({ id: `${LOCALE_PREFIX}.skImportFail` })

        // Get the response values for success message
        const importResult = getResponseObject(
            _.get(czechResponse, responseBodyPath, {}),
            _.get(skResponse, responseBodyPath, {})
        )

        success({ id: `${LOCALE_PREFIX}.importSuccessMsg`, values: { ...importResult } })
        yield put(loadGroupMembers(groupId, 0)) // Reload group members to update group entity list
        yield put(loadGroups()) // Reload groups
    } else {
        error({ id: `${LOCALE_PREFIX}.importFailedMsg` })
    }

    yield put(manageGroupsDialogSetRowLoading(index, false))

    if (newGroup) {
        yield all([take(`${LOAD_GROUP_MEMBERS_REQUEST}_${SUCCESS}`), take(SETUP_GROUP_STACK)])

        yield put(groupStackChangeNameBeingEdited(true))
    }

    return null
}
